import React, { useState, useEffect } from "react";
import ChequeImageViewer from "./cheque-image-viewer";
import SecurePDFViewer from "./secure-pdf-viewer";
import { Row, Col } from "react-flexbox-grid";
import { Button } from "react-md";
import { Modal } from "@material-ui/core";
import { CircularProgress } from "react-md";
import {
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Menu,
  IconButton,
  InputLabel,
  FormControl,
  Box,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  AccountBalanceOutlined,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import BankAccountService from "../../../../../ops/modules/patients/modules/new-bridge/services/BankAccountService";
import EventService from "../../../../../../service/event/EventService";
import { errorMessageHandler } from "../../../disqualification-module/utils/helperMethod";
import BankAccountSuccessScreen from "./bank-account-success-screen";

const BankAccountVerification = ({
  bankAccountResponse,
  handleCloseModal,
  getAllClaims,
  fetchMaskedBankAccountForPatient,
  setOpenBankAccountVerificationDialog,
  isBankAccountSuccessScreen,
  setIsBankAccountSuccessScreen,
  setBankAccountSuccessScreenHeading,
  setOpenChangeBankAccountMiddlewareDialog,
  setBankAccountSuccessScreenOnClickDoneCallback,
  menuFor,
}) => {
  const [showAccountNum, setShowAccountNum] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVerifyConfirmationScreen, setIsVerifyConfirmationScreen] =
    useState(false);
  const [isRejectConfirmationScreen, setIsRejectConfirmationScreen] =
    useState(false);

  const [rejectionReason, setRejectionReason] = useState();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [
    fetchFullBankAccountByIdResponse,
    setFetchFullBankAccountByIdResponse,
  ] = useState(null);
  const bankAccountService = new BankAccountService();

  const ACCOUNT_TYPE_MAP = {
    1: "Savings",
  };

  const BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 1;
  const BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 0;
  const BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED = 2;

  const getMaskedBankAccountNum = (last4, accNumLength) => {
    return "X".repeat(Math.abs(accNumLength - 4)) + (last4 ?? "").toString();
  };

  const getVerificationStatusColor = (verificationStatus) => {
    const colorMap = {
      0: "#FFBD2D",
      1: "#1BC47D",
      2: "#E44437",
    };
    return colorMap[verificationStatus ?? -1];
  };
  const getVerificationStatusLabel = (verificationStatus) => {
    const labelMap = {
      0: "Unverified",
      1: "Verified",
      2: "Rejected",
    };
    return labelMap[verificationStatus ?? -1];
  };

  const isZeroObjectId = (objId) => {
    const objectId = (objId ?? "").toString();
    if (!objectId) {
      return true;
    }
    if (objectId === "" || objectId === "000000000000000000000000") {
      return true;
    }
    return false;
  };

  const fetchFullBankAccountById = (accId) => {
    bankAccountService.fetchFullBankAccountById(
      accId,
      (res) => {
        setFetchFullBankAccountByIdResponse(res);
      },
      (err) => {
        EventService.emit("showError", {
          message:
            "Error fetching full bank account for the patient : " +
            errorMessageHandler(err).toString(),
        });
      }
    );
  };

  const updateBankAccount = (body) => {
    setLoading(true);
    bankAccountService.updateBankAccount(
      body,
      (res) => {
        setLoading(false);
        EventService.emit("showError", {
          message:
            res?.verificationStatus ===
            BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED
              ? "Bank Account verified successfully!"
              : res?.verificationStatus ===
                BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED
              ? "Bank Account rejected successfully!"
              : "Bank Account updated successfully with unknown verification status",
        });
        if (getAllClaims) {
          getAllClaims();
        }
        if (fetchMaskedBankAccountForPatient) {
          fetchMaskedBankAccountForPatient(menuFor?.patientId, res?.id);
        }
        setIsBankAccountSuccessScreen(true);
        setBankAccountSuccessScreenHeading(
          res?.verificationStatus === BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED
            ? "Bank Account verified successfully!"
            : res?.verificationStatus ===
              BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED
            ? "Bank Account rejected successfully!"
            : "Bank Account updated successfully with unknown verification status"
        );
        setOpenBankAccountVerificationDialog(false);
      },
      (err) => {
        setLoading(false);
        EventService.emit("showError", {
          message:
            "Error while updating bank account : " +
            errorMessageHandler(err).toString(),
        });
      }
    );
  };

  useEffect(() => {
    if (
      showAccountNum &&
      !isZeroObjectId(bankAccountResponse?.id) &&
      !Boolean(fetchFullBankAccountByIdResponse?.id) &&
      Boolean(
        bankAccountResponse?.verificationStatus ===
          BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED
      )
    ) {
      fetchFullBankAccountById(bankAccountResponse?.id);
    }
  }, [showAccountNum]);

  const getVerifyConfirmationScreen = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              fontSize: "24px",
              fontWeight: 700,
              fontFamily: "Montserrat",
              textAlign: "center",
            }}
          >
            Verify bank account
          </div>

          <IconButton onClick={handleCloseModal}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </div>
        <div style={{ height: "32px" }}></div>

        <div
          style={{
            textAlign: "center",
            width: "100%",
          }}
        >
          {" "}
          Are you sure you want to mark this account as verified?<br></br>{" "}
          <strong>Note: </strong>{" "}
          {" Once marked verfied, You will not be able to revert this action."}
        </div>

        <div style={{ height: "40px" }}></div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Button
            raised
            className={"mp-plan-button-save-enabled"}
            disabled={loading}
            onClick={() => {
              updateBankAccount({
                id: bankAccountResponse?.id,
                verificationStatus: BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED,
              });
            }}
          >
            Verify
          </Button>
        </div>
      </>
    );
  };

  const getCharCount = (editorState) =>
    editorState.getCurrentContent().getPlainText("").length;

  const handleEditorChange = (newState, setRejectionReason) => {
    setEditorState(newState);

    const rawContentState = convertToRaw(newState.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState);

    setRejectionReason(htmlContent);
  };

  const getRejectConfirmationScreen = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              fontSize: "24px",
              fontWeight: 700,
              fontFamily: "Montserrat",
              textAlign: "center",
            }}
          >
            Reject bank account
          </div>

          <IconButton onClick={handleCloseModal}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </div>
        <div style={{ height: "32px" }}></div>

        <TextField
          variant="outlined"
          fullWidth
          value={rejectionReason}
          required
          onChange={(e) => setRejectionReason(e.target.value)}
          disabled={loading}
          style={{ marginTop: "15px" }}
          InputProps={{
            style: { height: "400px", overflow: "auto", padding: "10px" },
            inputComponent: () => (
              <div style={{ height: "100%", overflow: "auto" }}>
                <Editor
                  editorState={editorState}
                  onEditorStateChange={(newState) =>
                    handleEditorChange(newState, setRejectionReason)
                  }
                  handleBeforeInput={(chars, state) => {
                    if (getCharCount(state) > 250) {
                      return "handled"; // blocks typing
                    }
                    return "not-handled";
                  }}
                  handlePastedText={(text, html, state) => {
                    if (getCharCount(state) + text.length > 250) {
                      return "handled"; // blocks paste
                    }
                    return "not-handled";
                  }}
                  stripPastedStyles={false}
                  placeholder="Rejection reason (to be shared with user) max. 250 characters"
                />
              </div>
            ),
          }}
        />

        <div style={{ height: "40px" }}></div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Button
            raised
            className={"mp-plan-button-reject-enabled"}
            disabled={loading}
            onClick={() => {
              updateBankAccount({
                id: bankAccountResponse?.id,
                verificationStatus: BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED,
                rejectionReason: rejectionReason,
              });
            }}
          >
            Reject
          </Button>
        </div>
      </>
    );
  };

  return (
    <div
      style={
        bankAccountResponse?.verificationStatus ===
        BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED
          ? { width: "90%", left: "45%" }
          : { width: "600px", left: "20%" }
      }
      className="custom-modal-content scrollable-modal-full-height"
    >
      {loading ? (
        <CircularProgress />
      ) : !Boolean(bankAccountResponse) ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "24px",
                fontWeight: 700,
                fontFamily: "Montserrat",
                textAlign: "center",
              }}
            ></div>

            <IconButton onClick={handleCloseModal}>
              <CloseIcon fontSize="large" />
            </IconButton>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
              height: "360px",
            }}
          >
            <AccountBalanceOutlined
              style={{ height: "160px", width: "160px", color: "#CED4DA" }}
            />
            <div>Error while fetching bank account for this claim</div>
          </div>
        </>
      ) : (
        <>
          {Boolean(
            bankAccountResponse?.verificationStatus ===
              BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED
          ) &&
            (Boolean(isRejectConfirmationScreen) ? (
              getRejectConfirmationScreen()
            ) : Boolean(isVerifyConfirmationScreen) ? (
              getVerifyConfirmationScreen()
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      fontSize: "24px",
                      fontWeight: 700,
                      fontFamily: "Montserrat",
                      textAlign: "center",
                    }}
                  >
                    Verify bank account
                  </div>

                  <IconButton onClick={handleCloseModal}>
                    <CloseIcon fontSize="large" />
                  </IconButton>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                  {Boolean(
                    (
                      bankAccountResponse?.chequeContentType ?? ""
                    ).toString() === "image/png" ||
                      (
                        bankAccountResponse?.chequeContentType ?? ""
                      ).toString() === "image/jpeg"
                  ) ? (
                    <ChequeImageViewer
                      bankAccountResponse={bankAccountResponse}
                    />
                  ) : (
                    <SecurePDFViewer
                      bankAccountResponse={bankAccountResponse}
                    />
                  )}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "32px",
                      width: "35%",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      label="Full name as per bank account"
                      required
                      placeholder="Full name as per bank account"
                      value={bankAccountResponse?.accountHolderName ?? ""}
                      disabled={true}
                    />

                    <div style={{ height: "16px" }}></div>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Account type"
                      label="Account type"
                      required
                      value={
                        ACCOUNT_TYPE_MAP[
                          bankAccountResponse?.accountType ?? -1
                        ] ?? ""
                      }
                      disabled={true}
                    />
                    <div style={{ height: "16px" }}></div>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Bank account number"
                      required
                      label="Bank account number"
                      value={
                        Boolean(showAccountNum)
                          ? fetchFullBankAccountByIdResponse?.accountNum ?? ""
                          : getMaskedBankAccountNum(
                              bankAccountResponse?.last4,
                              bankAccountResponse?.accNumLength
                            ) ?? ""
                      }
                      disabled={true}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {Boolean(showAccountNum) ? (
                              <IconButton
                                onClick={(e) => {
                                  setShowAccountNum((prev) => !prev);
                                }}
                              >
                                <Visibility />
                              </IconButton>
                            ) : (
                              <IconButton
                                onClick={(e) => {
                                  setShowAccountNum((prev) => !prev);
                                }}
                              >
                                <VisibilityOff />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <div style={{ height: "16px" }}></div>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="IFSC code"
                      required
                      label="IFSC code"
                      value={bankAccountResponse?.ifsc ?? ""}
                      disabled={true}
                    />
                    <div style={{ height: "16px" }}></div>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Bank name"
                      multiline
                      label="Bank name"
                      value={bankAccountResponse?.branchInfo?.bankName ?? ""}
                      disabled={true}
                    />
                    <div style={{ height: "16px" }}></div>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Branch name"
                      multiline
                      label="Branch name"
                      value={bankAccountResponse?.branchInfo?.branchName ?? ""}
                      disabled={true}
                    />
                    <div style={{ height: "16px" }}></div>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Branch address"
                      multiline
                      label="Branch address"
                      value={bankAccountResponse?.branchInfo?.address ?? ""}
                      disabled={true}
                    />

                    <div style={{ height: "40px" }}></div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <Button
                        raised
                        className={"mp-plan-button-reject-enabled"}
                        disabled={loading}
                        onClick={() => {
                          // updateBankAccount({
                          //   id: bankAccountResponse?.id,
                          //   verificationStatus:
                          //     BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED,
                          // });
                          setIsRejectConfirmationScreen(true);
                        }}
                      >
                        Reject
                      </Button>
                      <Button
                        raised
                        className={"mp-plan-button-save-enabled"}
                        disabled={loading}
                        onClick={() => {
                          // updateBankAccount({
                          //   id: bankAccountResponse?.id,
                          //   verificationStatus:
                          //     BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED,
                          // });
                          setIsVerifyConfirmationScreen(true);
                        }}
                      >
                        Verify
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            ))}

          {Boolean(
            bankAccountResponse?.verificationStatus === 1 ||
              bankAccountResponse?.verificationStatus === 2
          ) && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    fontSize: "24px",
                    fontWeight: 700,
                    fontFamily: "Montserrat",
                    textAlign: "center",
                  }}
                >
                  Bank account
                </div>

                <IconButton onClick={handleCloseModal}>
                  <CloseIcon fontSize="large" />
                </IconButton>
              </div>

              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "32px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      overflow: "hidden",
                      border: "1px solid #CED4DA",
                      borderRadius: "4px",
                      paddingTop: "16px",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      paddingBottom: "16px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "500px",
                    }}
                  >
                    <div style={{ fontSize: 14 }}>Verification status</div>
                    <div
                      style={{
                        backgroundColor:
                          getVerificationStatusColor(
                            bankAccountResponse?.verificationStatus
                          ) ?? "",
                      }}
                      onClick={() => {}}
                    >
                      <div
                        style={{
                          color: "white",
                          paddingTop: "4px",
                          paddingBottom: "4px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          border: "1px solid white",
                          borderRadius: "4px",
                          fontWeight: 700,
                        }}
                      >
                        {getVerificationStatusLabel(
                          bankAccountResponse?.verificationStatus
                        ) ?? ""}
                      </div>
                    </div>
                  </div>
                  <div style={{ height: "16px" }}></div>

                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    label="Full name as per bank account"
                    required
                    placeholder="Full name as per bank account"
                    value={bankAccountResponse?.accountHolderName ?? ""}
                    disabled={true}
                  />

                  <div style={{ height: "16px" }}></div>
                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Account type"
                    label="Account type"
                    required
                    value={
                      ACCOUNT_TYPE_MAP[
                        bankAccountResponse?.accountType ?? -1
                      ] ?? ""
                    }
                    disabled={true}
                  />
                  <div style={{ height: "16px" }}></div>
                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Bank account number"
                    required
                    label="Bank account number"
                    value={
                      getMaskedBankAccountNum(
                        bankAccountResponse?.last4,
                        bankAccountResponse?.accNumLength
                      ) ?? ""
                    }
                    disabled={true}
                  />
                  <div style={{ height: "16px" }}></div>
                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    placeholder="IFSC code"
                    required
                    label="IFSC code"
                    value={bankAccountResponse?.ifsc ?? ""}
                    disabled={true}
                  />
                  <div style={{ height: "16px" }}></div>
                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Bank name"
                    multiline
                    label="Bank name"
                    value={bankAccountResponse?.branchInfo?.bankName ?? ""}
                    disabled={true}
                  />
                  <div style={{ height: "16px" }}></div>
                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Branch name"
                    multiline
                    label="Branch name"
                    value={bankAccountResponse?.branchInfo?.branchName ?? ""}
                    disabled={true}
                  />
                  <div style={{ height: "16px" }}></div>
                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Branch address"
                    multiline
                    label="Branch address"
                    value={bankAccountResponse?.branchInfo?.address ?? ""}
                    disabled={true}
                  />

                  <div style={{ height: "40px" }}></div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => {
                        handleCloseModal();
                        setOpenBankAccountVerificationDialog(false);
                        setOpenChangeBankAccountMiddlewareDialog(true);
                      }}
                      className="full-width-button"
                      disabled={loading}
                      style={{
                        backgroundColor: loading ? "#e0e0e0" : "#f57c00",
                        color: "#fff",
                        marginTop: "20px",
                      }}
                    >
                      Change account
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

// ) : (
//   <SecurePDFViewer bankAccountResponse={bankAccountResponse} />
// )}

export default BankAccountVerification;
